export class EntidadCodigoStringDTO{
    id?: number;
    guidRegistro?: string;
    referenciaExterna?: string;
    codigo?: string;
    nombre?: string;
}